import {
  type USStateData,
  usStateData,
  washingtonDCUSStateData,
} from "shared/helpers/profile/address/us-state/usStateData";

type GetUSStateInformationParams = {
  /** The state as stored on an address, e.g. "California" or "CA". */
  state: string;
  /**
   * When `true`, returns `undefined` if no state matches.
   * When omitted or `false`, an unmatched state falls back to Washington DC,
   * which existing callers (sales tax, Authorize.net, Billhighway) rely on.
   * Pass `true` when a wrong guess is worse than no answer, e.g. for display.
   */
  noFallback?: boolean;
};

/**
 * Looks up a US state by name or two-letter code (case-insensitive).
 * Falls back to Washington DC unless `noFallback` is `true`.
 */
export const getUSStateInformation = ({
  state,
  noFallback,
}: GetUSStateInformationParams): USStateData | undefined => {
  const input = state.toLowerCase();
  const match = usStateData.find(
    (usState) =>
      usState.iso2code.toLowerCase() === input ||
      usState.name.toLowerCase() === input,
  );
  if (match || noFallback) {
    return match;
  }
  //Since no match was found and noFallback is not true, we fall back to Washington DC.
  return washingtonDCUSStateData;
};
